module.exports = __webpack_public_path__ + "img/5.f0f7b2a7.jpg";